<template>
 <div class="page">
   {{$t('pageNumber')}}: <span v-show="config.id">{{pageNumber}}</span>
</div>
</template>

<script>
export default {
  name: 'PageBox',
  props: ['config'],
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    pageNumber () {
      const config = this.config
      return `${config.pageSize}/${config.pageTotal}`
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {
  }
}
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/PageBox/PageBox.vue